import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import type { UserOptions } from 'jspdf-autotable';
import { TableColumns } from '../models/table-columns';
/* eslint-disable */

export type HeaderText = { text: string; fontSize?: number }[];

export function pdf(
	element: HTMLTableElement,
	orientations: 'landscape' | 'portrait' = 'portrait',
	removeLastColumn = true,
	headerText: HeaderText = [],
	columns: TableColumns<any> = [],
	watermark: string = null
): Promise<void> {
	return new Promise((resolve) => {
		const head = [];
		const body = [];

		element.querySelectorAll('thead th').forEach((e: HTMLElement) => head.push(e.innerText.trim()));
		if (removeLastColumn) {
			head.pop();
		}

		element.querySelectorAll('tbody tr').forEach((tr: HTMLElement) => {
			const trData = [];
			tr.querySelectorAll('td').forEach((td: HTMLElement) => trData.push(td.innerText.trim()));
			if (removeLastColumn) {
				trData.pop();
			}
			body.push(trData);
		});

		element.querySelectorAll('tfoot tr').forEach((tr: HTMLElement) => {
			const trData = [];
			tr.querySelectorAll('td').forEach((td: HTMLElement) => trData.push(td.innerText.trim()));
			if (removeLastColumn) {
				trData.pop();
			}
			body.push(trData);
		});

		// const exportColumns = selectedColumns.map(col => ({ title: col.header, dataKey: col.field }));

		// const doc = new jsPDF('portrait', 'in', 'A4');
		// doc.setLanguage("tr")
		// doc['autoTable'](exportColumns, data);
		const currentDate = new Date();
		// doc.save(`export-pdf-${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getFullYear()}-${currentDate.getDay()}`);
		// table role="grid

		// var doc = new jsPDF()
		// doc['autoTable']({ html: 'table[role="grid"]' })
		// doc.save('table.pdf')

		const doc = new jsPDF(orientations);
		doc.addFont('assets/fonts/Roboto-Regular.ttf', 'roboto', '');
		doc.addFont('assets/fonts/Roboto-Thin.ttf', 'roboto', 'light');
		doc.setFont('roboto', '');
		// console.log(doc.getFontList())
		// doc.setFontSize(8);
		// debugger
		const line = 5;
		const prefix = 5;
		// console.log(doc.getFontSize())
		// doc.text('With content', 14, line);
		// doc.setFontSize(11)
		// doc.text('With content', 14, line * 2);
		// doc.text('With content', 14, line * 3);
		// doc.setFontSize(8)
		// doc.text('With content', 14, line * 4);
		for (const [index, row] of headerText.entries()) {
			if (row.fontSize) {
				doc.setFontSize(row.fontSize);
			}
			doc.text(row.text, 14, line * (index + 1) + prefix);
		}
		const columnStyles: NonNullable<UserOptions['columnStyles']> = columns.reduce(
			(acc, col, index) => {
				if (col.type === 'number') {
					acc[String(index)] = { halign: 'right' };
				}
				return acc;
			},
			{} as NonNullable<UserOptions['columnStyles']>
		);

		autoTable(doc, {
			startY: line * (headerText.length + 1) + prefix,
			styles: { font: 'roboto' },
			columnStyles,
			head: [head],
			body,
			showHead: 'firstPage',
			didDrawPage: () => {
				if (watermark !== null) {
					addWatermark(doc, watermark);
				}
			},
		});
		doc.save(`export-pdf-${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`);

		resolve();
	});
}

function addWatermark(doc: jsPDF, watermark: string): void {
	const img = new Image();
	img.src = watermark;
	doc.addImage(img, 'PNG', 15, 40, 180, 160, undefined, 'FAST');

	// const pageSize = doc.internal.pageSize;
	// const width = pageSize.getWidth();
	// const height = pageSize.getHeight();

	// doc.addImage(
	// 	img,
	// 	'PNG',
	// 	width / 2 - img.width / 4,
	// 	height / 2 - img.height / 4,
	// 	img.width / 2,
	// 	img.height / 2,
	// 	'',
	// 	'FAST'
	// );
}
